export const isNullish = (value: unknown) => {
  return value === null || value === undefined;
};
